// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5dc9e1da","455":"dc86009d","977":"555b6447"}[chunkId] + ".chunk.js";
};